import { memo, useEffect } from 'react';
import { Keyboard } from 'react-native';
import { FadeOut } from 'react-native-reanimated';
import { Box, Icon, Text } from '@bonanza-social/moonlight';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectBiometricsDataState } from '../../state/biometrics/biometrics.slice';

function BiometricsVerification() {
  const biometricsDataState = useSelector(selectBiometricsDataState);
  const visible =
    biometricsDataState === 'pending' || biometricsDataState === 'fulfilled';

  useEffect(() => {
    if (visible) {
      Keyboard.dismiss();
    }
  }, [visible]);

  return (
    visible && (
      <Box
        position="absolute"
        backgroundColor="screenBackground"
        exiting={FadeOut}
        centerContent
        inset={0}
      >
        <Box alignItems="center" flexDirection="row">
          <Icon
            name="bonanzaCoin"
            width={54}
            height={54}
            gradient="accentBackground"
          />
          <Box flexDirection="row">
            <Icon
              name="BonanzaLogo"
              marginLeft="space-200"
              marginTop="space-200"
              width={87}
              height={38}
            />
            <Text
              variant="caption"
              gradient="darkSurfaceAccent"
              paddingLeft="space-100"
              paddingTop="space-200"
            >
              ®
            </Text>
          </Box>
        </Box>
      </Box>
    )
  );
}

export default memo(BiometricsVerification);
